export default __webpack_public_path__ + "static/media/idsvg.e4cc866f.svg";